import { Box, styled } from '@mui/joy'

export const Wrapper = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
`
